export default (state = {data:{}}, action = {}) => {
  switch(action.type) {
    case 'FETCH_REQUS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_REQUS':
      return {
        ...state,
        sort: action.sort
      }
    case 'FILTER_REQUS':
      return {
        ...state,
        filter: action.filter
      }
    case 'SEARCH_REQUS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_REQU':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.requ_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/requs.js